module.exports = __webpack_public_path__ + "img/logo2.76b55297.svg";